export const $VatInfoModuleName = "vatInfo";

export type TVatInfoState = {
    isLoading: boolean;
    data: null | any;
};
